export default {
  DEFAULT_LOGO_WIDTH: 46,
  DEFAULT_THEME: 'dark',
};
